import { CodeBase } from "./_codeBase";

/** 実績区分*/
export class ResultProgressDiv extends CodeBase<ResultProgressDiv>
{

    /** 実績区分:"a", "　", "　"*/
    public static readonly A: ResultProgressDiv = new ResultProgressDiv("a", "　", "　");

    /** 実績区分:"b", "新規", "○"*/
    public static readonly B: ResultProgressDiv = new ResultProgressDiv("b", "新規", "○");

    /** 実績区分:"d", "完了", "●"*/
    public static readonly D: ResultProgressDiv = new ResultProgressDiv("d", "完了", "●");

    /** 実績区分:"f", "中断", "△"*/
    public static readonly F: ResultProgressDiv = new ResultProgressDiv("f", "中断", "△");

    /** 実績区分:"g", "該当無", "×"*/
    public static readonly G: ResultProgressDiv = new ResultProgressDiv("g", "該当無", "×");

    /** 実績区分:"e", "完了見込", "▲"*/
    public static readonly E: ResultProgressDiv = new ResultProgressDiv("e", "完了見込", "▲");

    /** 実績区分:"i", "キャンセル", "■"*/
    public static readonly I: ResultProgressDiv = new ResultProgressDiv("i", "キャンセル", "■");

    /** 実績区分:"j", "進捗率(10%)", "10%"*/
    public static readonly J: ResultProgressDiv = new ResultProgressDiv("j", "進捗率(10%)", "10%");

    /** 実績区分:"k", "進捗率(20%)", "20%"*/
    public static readonly K: ResultProgressDiv = new ResultProgressDiv("k", "進捗率(20%)", "20%");

    /** 実績区分:"l", "進捗率(30%)", "30%"*/
    public static readonly L: ResultProgressDiv = new ResultProgressDiv("l", "進捗率(30%)", "30%");

    /** 実績区分:"m", "進捗率(40%)", "40%"*/
    public static readonly M: ResultProgressDiv = new ResultProgressDiv("m", "進捗率(40%)", "40%");

    /** 実績区分:"n", "進捗率(50%)", "50%"*/
    public static readonly N: ResultProgressDiv = new ResultProgressDiv("n", "進捗率(50%)", "50%");

    /** 実績区分:"o", "進捗率(60%)", "60%"*/
    public static readonly O: ResultProgressDiv = new ResultProgressDiv("o", "進捗率(60%)", "60%");

    /** 実績区分:"p", "進捗率(70%)", "70%"*/
    public static readonly P: ResultProgressDiv = new ResultProgressDiv("p", "進捗率(70%)", "70%");

    /** 実績区分:"q", "進捗率(80%)", "80%"*/
    public static readonly Q: ResultProgressDiv = new ResultProgressDiv("q", "進捗率(80%)", "80%");

    /** 実績区分:"r", "進捗率(90%)", "90%"*/
    public static readonly R: ResultProgressDiv = new ResultProgressDiv("r", "進捗率(90%)", "90%");

    /** 実績区分:"s", "進捗率(100%)", "100%"*/
    public static readonly S: ResultProgressDiv = new ResultProgressDiv("s", "進捗率(100%)", "100%");

    /** 実績区分:"c", "継続", "◎"*/
    public static readonly C: ResultProgressDiv = new ResultProgressDiv("c", "継続", "◎");

    /** 実績区分:"h", "予定提出後に変更", "◇"*/
    public static readonly H: ResultProgressDiv = new ResultProgressDiv("h", "予定提出後に変更", "◇");


    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): ResultProgressDiv[] {
        return [
            // 並び順を変更（#6213 V2.4）
            //ResultProgressDiv.A,
            //ResultProgressDiv.B,
            //ResultProgressDiv.C,
            //ResultProgressDiv.D,
            //ResultProgressDiv.E,
            //ResultProgressDiv.F,
            //ResultProgressDiv.G,
            //ResultProgressDiv.H,
            //ResultProgressDiv.I,
            //ResultProgressDiv.J,
            //ResultProgressDiv.K,
            //ResultProgressDiv.L,
            //ResultProgressDiv.M,
            //ResultProgressDiv.N,
            //ResultProgressDiv.O,
            //ResultProgressDiv.P,
            //ResultProgressDiv.Q,
            //ResultProgressDiv.R,
            //ResultProgressDiv.S,
            ResultProgressDiv.A,
            ResultProgressDiv.B,
            ResultProgressDiv.D,
            ResultProgressDiv.F,
            ResultProgressDiv.G,
            ResultProgressDiv.E,
            ResultProgressDiv.I,
            ResultProgressDiv.J,
            ResultProgressDiv.K,
            ResultProgressDiv.L,
            ResultProgressDiv.M,
            ResultProgressDiv.N,
            ResultProgressDiv.O,
            ResultProgressDiv.P,
            ResultProgressDiv.Q,
            ResultProgressDiv.R,
            ResultProgressDiv.S,
            ResultProgressDiv.C,
            ResultProgressDiv.H,
        ];
    }
}
